import React, { Component } from 'react';
import * as GetServices from '../../actions/Services';
import * as AppointmentReducer from '../../actions/Appointment';
import * as GetAppointmentPageText from '../../actions/AppointmentPageText';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import RadioGroup from "antd/lib/radio/group";
import { Radio } from "antd";

export class ContentHeader extends Component {
    componentDidMount() {
        this.props.servicesDispath.LoadServices()
        this.props.pageTextLoader.LoadText()
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        if (!this.state.pageText && prevProps.pageText) {
            this.setState({pageText: prevProps.pageText})
        }
    }

    constructor() {
        super();
        this.state = {
            id: null,
            gender: null
        };
    }

    changeId = (event) => {
        this.setState({id: event.target.value});
        if(this.state.gender){
            this.props.schedule.Load(0, event.target.value, this.state.gender)
        }
    }

    changeGender = (event) => {
        this.setState({gender: event.target.value});
        if (this.state.id) {
            this.props.schedule.Load(0, this.state.id, event.target.value)
        }
    }

    render(){
        return(
            <div>
                <div className="content__header">
                    <h1>Запись на медосмотр</h1>
                    <div dangerouslySetInnerHTML={{ __html: this.props.pageText ? this.props.pageText : this.state.pageText }} />
                </div>
                <div className="content_filters">
                    <div className="content_filters_filter">
                        <h4>Пол</h4>
                        <RadioGroup onChange={this.changeGender} name={"gender"}>
                            <Radio value={"male"}>Мужской</Radio>
                            <Radio value={"female"}>Женский</Radio>
                        </RadioGroup>
                    </div>
                    <br/>
                    <div className="content_filters_filter">
                        <h4>Услуга</h4>
                        <select onChange={this.changeId} defaultValue="0" name="filter">
                            <option value="0" disabled hidden>Выберите услугу</option>
                            {this.props.services.map(services => {
                                return (
                                    <option key={services.id} value={`${services.id}`}>{services.name}</option>
                                    )
                                })}
                        </select>
                    </div>
                </div>
            </div>
        );
    }
}

const mapStateToProps = state => ({
    id: state.AppointmentReducer.id,
    gender: state.AppointmentReducer.gender,
    services: state.GetServices.services,
    pageText: state.AppointmentPageTextReducer.text
});

function mapDispatchToProps(dispatch) {
    return {
        servicesDispath: bindActionCreators(GetServices, dispatch),
        schedule: bindActionCreators(AppointmentReducer, dispatch),
        pageTextLoader: bindActionCreators(GetAppointmentPageText, dispatch)
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(ContentHeader);



// WEBPACK FOOTER //
// frontend/src/modules/content/content-header.jsx